import React from 'react';
import Well from '../Well/Well';
import cx from 'classnames';
import styles from './ExtensionsComponent.module.scss';
import { browserName } from 'react-device-detect';
import { CustomButton } from '../Button/Button';
import configs from '../../../../conf';
import { useTranslation } from 'react-i18next';
const config = configs[process.env.APP_CONF];

const extensionId = process.env.EXT_ID;
const chromeWebStoreUrl = config.chromeWebStoreUrl;
const edgeWebStoreUrl = config.edgeWebStoreUrl;

const ExtensionsComponent = ({
  handleNextStep,
  disableNext,
  loading,
  chromeExtensionInstalled,
  edgeExtensionInstalled,
  handleFinishOnboarding,
}) => {
  const { t } = useTranslation();

  return (
    <div id="step1">
      <h1 className={styles.title}>{t('onboarding.title')}</h1>

      <div className={styles.cardContainer}>
        <div className={styles.onboardingCard}>
          <div className={styles.onboardingDescription}>
            {browserName !== 'Edge' && (
              <Well
                title={t('onboarding.chrome.title')}
                body={t('onboarding.body')}
                icon="chrome"
                btnType={chromeExtensionInstalled ? t('onboarding.btn.installed') : t('onboarding.btn.download')}
                installed={chromeExtensionInstalled}
                btnLink={chromeWebStoreUrl}
                handleNextStep={handleNextStep}
              />
            )}

            {browserName !== 'Chrome' && (
              <Well
                title={t('onboarding.edge.title')}
                body={t('onboarding.body')}
                icon="edge"
                btnType={edgeExtensionInstalled ? t('onboarding.btn.installed') : t('onboarding.btn.download')}
                installed={edgeExtensionInstalled}
                btnLink={edgeWebStoreUrl}
                handleNextStep={handleNextStep}
              />
            )}
          </div>

          <div className={styles.btnsContainer}>
            <CustomButton label="Skip" variant="link" className={styles.skipButton} onClick={handleFinishOnboarding} />
            <CustomButton
              className={cx(
                {
                  submit: !disableNext && !loading,
                  'no-submit': disableNext || loading,
                },
                'next',
                styles.nextBtn
              )}
              variant={'primary'}
              onClick={handleNextStep}
              loading={loading}
              loadingText="Moving to next step"
              disabled={disableNext}
              label={t('onboarding.btn.next')}
              customStyles={{ width: '160px', justifyContent: 'center' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtensionsComponent;
